export interface KTPType {
  id: string;
  title: string;
  description: string;
  features: string[];
  specifications: {
    name: string;
    value: string;
  }[];
  advantages: string[];
  applications: string[];
  image_url: string;
  seo_text: string;
  utp: string[];
  offers: string[];
  cta: {
    title: string;
    description: string;
  };
}

export const ktpTypes: Record<string, KTPType> = {
  ktp: {
    id: 'ktp',
    title: 'КТПВ (Комплектная трансформаторная подстанция внутренней установки)',
    description: 'Комплектные трансформаторные подстанции внутренней установки (КТПВ) предназначены для приема, преобразования и распределения электрической энергии внутри помещений. Они идеально подходят для промышленных предприятий, административных зданий и других объектов, где требуется надежное и эффективное электроснабжение в условиях ограниченного пространства.',
    features: [
      'Мощность от 100 до 4000 кВА',
      'Напряжение 6-10/0,4 кВ',
      'Внутренняя установка',
      'Климатическое исполнение У1'
    ],
    specifications: [
      { name: 'Мощность силового трансформатора', value: '100–4000 кВА' },
      { name: 'Номинальное напряжение (высокое)', value: '6 или 10 кВ' },
      { name: 'Номинальное напряжение (низкое)', value: '0,23; 0,4; 0,6; 0,69 кВ' },
      { name: 'Частота', value: '50 Гц' },
      { name: 'Климатическое исполнение', value: 'У1 (умеренный климат)' }
    ],
    advantages: [
      'Удобство обслуживания благодаря наличию окон для визуального контроля без отключения напряжения',
      'Возможность замены силового трансформатора без демонтажа других устройств',
      'Высокая механическая прочность и надежность',
      'Готовность к эксплуатации после минимальной сборки на месте',
      'Интеграция с системами мониторинга и управления'
    ],
    applications: [
      'Промышленные предприятия',
      'Административные здания',
      'Коммерческие объекты',
      'Производственные цеха'
    ],
    image_url: '/images/ktp/ktpv.jpg',
    seo_text: 'Комплектные трансформаторные подстанции внутренней установки КТПВ — это надежное решение для электроснабжения промышленных и административных объектов. С мощностью от 100 до 4000 кВА и напряжением до 10 кВ, эти подстанции обеспечивают эффективное преобразование и распределение электроэнергии. Благодаря современному дизайну и высококачественным компонентам, КТПВ отличаются долговечностью и простотой в обслуживании. Установка КТПВ внутри помещений позволяет защитить оборудование от внешних воздействий и обеспечить бесперебойную работу электросети.',
    utp: [
      'Экономия до 10% на электроэнергии благодаря инновационным технологиям',
      'Быстрая установка и минимальное обслуживание — экономия времени и ресурсов',
      'Гарантия 36 месяцев — ваша уверенность в качестве'
    ],
    offers: [
      'Скидка 5% при заказе до конца месяца!',
      'Бесплатная доставка по РФ при покупке от 2 подстанций'
    ],
    cta: {
      title: 'Получите расчет за 1 час',
      description: 'Начните экономить уже сегодня!'
    }
  },
  ktpn: {
    id: 'ktpn',
    title: 'КТПН — защита от любых погодных условий для вашего бизнеса!',
    description: 'Надежное электроснабжение круглый год с КТПН. Прочный металлический корпус и экономия до 10% на электроэнергии — ваш бизнес под защитой! Срок поставки — от 50 дней.',
    features: [
      'Мощность силового трансформатора: 25–4000 кВА',
      'Номинальное напряжение (высокое): 6 или 10 кВ',
      'Номинальное напряжение (низкое): 0,23; 0,4; 0,6; 0,69 кВ',
      'Частота: 50 Гц',
      'Климатическое исполнение: У1, УХЛ1 (холодный умеренный)'
    ],
    specifications: [
      { name: 'Мощность силового трансформатора', value: '25–4000 кВА' },
      { name: 'Номинальное напряжение (высокое)', value: '6 или 10 кВ' },
      { name: 'Номинальное напряжение (низкое)', value: '0,23; 0,4; 0,6; 0,69 кВ' },
      { name: 'Частота', value: '50 Гц' },
      { name: 'Климатическое исполнение', value: 'У1, УХЛ1 (холодный умеренный)' }
    ],
    advantages: [
      'Высокая степень защиты оборудования от атмосферных воздействий, таких как дождь, ветер и пыль',
      'Возможность установки в сложных климатических условиях, включая регионы с низкими температурами',
      'Удобство обслуживания благодаря модульной конструкции, что снижает затраты на техническое обслуживание',
      'Готовность к эксплуатации после доставки на объект, что ускоряет процесс ввода в эксплуатацию'
    ],
    applications: [
      'Промышленные предприятия',
      'Коммунальные объекты',
      'Строительные площадки',
      'Сельскохозяйственные объекты'
    ],
    image_url: '/images/ktp/ktpn.jpg',
    seo_text: 'Комплектные трансформаторные подстанции наружной установки КТПН — это идеальное решение для электроснабжения объектов, расположенных на открытых площадках. С мощностью от 25 до 4000 кВА и напряжением до 10 кВ, эти подстанции обеспечивают надежное преобразование и распределение электроэнергии. Выполненные в киосковом металлическом исполнении, КТПН защищены от атмосферных осадков, ветра и других внешних факторов, что гарантирует их долгосрочную эксплуатацию. Установка КТПН позволяет быстро и эффективно организовать электроснабжение промышленных, коммунальных и других объектов.',
    utp: [
      'Прочный корпус — защита от дождя, ветра и пыли',
      'Экономия до 10% на электроэнергии',
      'Доставка по РФ и СНГ — всегда вовремя'
    ],
    offers: [
      'Бесплатная консультация по подбору оборудования',
      'Гарантия лучшей цены — найдете дешевле, снизим стоимость!'
    ],
    cta: {
      title: 'Закажите КТПН и получите бесплатный расчет проекта!',
      description: 'Начните экономить уже сегодня!'
    }
  },
  ktpnu: {
    id: 'ktpnu',
    title: 'КТПНУ — тепло и надежность для вашего бизнеса в холодных регионах!',
    description: 'Бесперебойная работа даже при -60°C с КТПНУ. Утепленный корпус из сэндвич-панелей экономит на отоплении, а срок готовности — всего 50-75 дней.',
    features: [
      'Мощность силового трансформатора: 25–4000 кВА',
      'Номинальное напряжение (высокое): 6 или 10 кВ',
      'Номинальное напряжение (низкое): 0,23; 0,4; 0,6; 0,69 кВ',
      'Климатическое исполнение: УХЛ1 (холодный умеренный климат)'
    ],
    specifications: [
      { name: 'Мощность силового трансформатора', value: '25–4000 кВА' },
      { name: 'Номинальное напряжение (высокое)', value: '6 или 10 кВ' },
      { name: 'Номинальное напряжение (низкое)', value: '0,23; 0,4; 0,6; 0,69 кВ' },
      { name: 'Климатическое исполнение', value: 'УХЛ1 (холодный умеренный климат)' }
    ],
    advantages: [
      'Утепленный корпус обеспечивает работу оборудования при температурах до -60°C, что идеально для суровых зим',
      'Высокая степень защиты от атмосферных воздействий, включая влагу и пыль',
      'Удобство транспортировки и установки благодаря модульной конструкции, что снижает затраты на логистику',
      'Возможность быстрой сборки на объекте, что ускоряет процесс ввода в эксплуатацию'
    ],
    applications: [
      'Северные регионы',
      'Горнодобывающая промышленность',
      'Нефтегазовый сектор',
      'Удаленные объекты'
    ],
    image_url: '/images/ktp/ktpnu.jpg',
    seo_text: 'Комплектные трансформаторные подстанции утепленные КТПНУ — это специализированное оборудование для регионов с холодным климатом. Благодаря корпусу из сендвич-панелей, КТПНУ обеспечивают надежную защиту оборудования от низких температур, что позволяет эксплуатировать их круглый год. С мощностью от 25 до 4000 кВА, эти подстанции идеально подходят для электроснабжения объектов в суровых климатических условиях. Установка КТПНУ гарантирует бесперебойную работу электросети даже в самые холодные зимы.',
    utp: [
      'Утепленный корпус — защита от мороза и экономия на обогреве',
      'Быстрая установка — готовность за 50-75 дней',
      'Экономия до 10% на электроэнергии'
    ],
    offers: [
      'Скидка 10% на утепленные подстанции до конца сезона!',
      'Бесплатная доставка для клиентов из холодных регионов'
    ],
    cta: {
      title: 'Получите бесплатный расчет для вашего региона!',
      description: 'Начните экономить уже сегодня!'
    }
  },
  bktp: {
    id: 'bktp',
    title: 'БКТП — гибкость и надежность для вашего проекта!',
    description: 'Адаптируйте электроснабжение под любые задачи с БКТП. Модульная конструкция и монолитный железобетонный корпус обеспечивают максимальную надежность и простоту монтажа.',
    features: [
      'Мощность силового трансформатора: до 2500 кВА',
      'Номинальное напряжение (высокое): 6 или 10 кВ',
      'Номинальное напряжение (низкое): 0,4 кВ',
      'Конструкция: блочная, с возможностью расширения',
      'Корпус: монолитный железобетон'
    ],
    specifications: [
      { name: 'Мощность силового трансформатора', value: 'до 2500 кВА' },
      { name: 'Номинальное напряжение (высокое)', value: '6 или 10 кВ' },
      { name: 'Номинальное напряжение (низкое)', value: '0,4 кВ' },
      { name: 'Конструкция', value: 'блочная, с возможностью расширения' },
      { name: 'Корпус', value: 'монолитный железобетон' }
    ],
    advantages: [
      'Гибкость в конфигурации и расширении, что позволяет адаптировать подстанцию под конкретные задачи',
      'Высокая надежность благодаря использованию монолитного железобетона, обеспечивающего защиту от внешних воздействий',
      'Легкость монтажа и обслуживания, что снижает эксплуатационные расходы',
      'Возможность установки в плотно застроенных районах благодаря компактности'
    ],
    applications: [
      'Промышленные предприятия',
      'Городская инфраструктура',
      'Жилые комплексы',
      'Торговые центры'
    ],
    image_url: '/images/ktp/bktp.jpg',
    seo_text: 'Блочные комплектные трансформаторные подстанции БКТП — это современное решение для электроснабжения, которое отличается гибкостью и надежностью. Состоящие из отдельных блоков, БКТП позволяют легко адаптировать подстанцию под конкретные нужды заказчика. Выполненные из монолитного железобетона, эти подстанции обеспечивают долгосрочную эксплуатацию и защиту оборудования. Установка БКТП идеально подходит для промышленных предприятий, где требуется мощное и надежное электроснабжение.',
    utp: [
      'Модульная конструкция — адаптация под любые задачи',
      'Монолитный железобетон — максимальная надежность',
      'Быстрый монтаж — экономия времени и средств'
    ],
    offers: [
      'Бесплатная консультация по подбору конфигурации',
      'Гарантия лучшей цены — найдете дешевле, снизим стоимость!'
    ],
    cta: {
      title: 'Получите бесплатный расчет проекта!',
      description: 'Начните экономить уже сегодня!'
    }
  },
  ktpp: {
    id: 'ktpp',
    title: 'КТПП — мобильное электроснабжение для вашего бизнеса!',
    description: 'Электроснабжение в любом месте с КТПП. Мобильность, быстрая установка и экономия до 10% на электроэнергии — идеально для временных объектов. Готовность — 50-75 дней.',
    features: [
      'Мощность силового трансформатора: 25–4000 кВА',
      'Номинальное напряжение (высокое): 6 или 10 кВ',
      'Номинальное напряжение (низкое): 0,4 кВ',
      'Исполнение: на шасси или салазках'
    ],
    specifications: [
      { name: 'Мощность силового трансформатора', value: '25–4000 кВА' },
      { name: 'Номинальное напряжение (высокое)', value: '6 или 10 кВ' },
      { name: 'Номинальное напряжение (низкое)', value: '0,4 кВ' },
      { name: 'Исполнение', value: 'на шасси или салазках' }
    ],
    advantages: [
      'Высокая мобильность и быстрота развертывания, что экономит время при организации электроснабжения',
      'Возможность использования в экстренных ситуациях или на стройплощадках, обеспечивая оперативное восстановление энергии',
      'Полная готовность к эксплуатации после доставки, что минимизирует простои',
      'Экономия ресурсов благодаря отсутствию необходимости в капитальном строительстве'
    ],
    applications: [
      'Строительные площадки',
      'Временные объекты',
      'Аварийные ситуации',
      'Мобильные производства'
    ],
    image_url: '/images/ktp/ktpp.jpg',
    seo_text: 'Комплектные трансформаторные подстанции передвижного исполнения КТПП — это мобильное решение для временного электроснабжения. Установленные на шасси или салазках, КТПП могут быстро перемещаться и развертываться на нужном объекте. С мощностью от 25 до 4000 кВА, эти подстанции идеально подходят для стройплощадок, временных объектов или в случае аварий. Благодаря своей мобильности, КТПП обеспечивают оперативное восстановление электроснабжения в критических ситуациях.',
    utp: [
      'Мобильность — перемещайте подстанцию по необходимости',
      'Экономия до 10% на электроэнергии',
      'Быстрая установка — готовность за 50-75 дней'
    ],
    offers: [
      'Скидка 15% на передвижные подстанции до конца месяца!',
      'Бесплатная доставка по РФ при заказе от 2 подстанций'
    ],
    cta: {
      title: 'Получите расчет за 1 час и начните экономить уже сегодня!',
      description: 'Начните экономить уже сегодня!'
    }
  },
  ktps: {
    id: 'ktps',
    title: 'КТП для особых условий — надежность в любых испытаниях!',
    description: 'Пылевлагозащищенные КТП и КТП для особых условий эксплуатации — ваша гарантия стабильного электроснабжения в любых условиях. Работаем при температурах от -60°C до +50°C, в пыли, влаге и агрессивных средах.',
    features: [
      'Мощность силового трансформатора: 25–4000 кВА',
      'Номинальное напряжение (высокое): 6 или 10 кВ',
      'Номинальное напряжение (низкое): 0,4 кВ',
      'Степень защиты: IP54-IP65',
      'Температурный режим: от -60°C до +50°C'
    ],
    specifications: [
      { name: 'Мощность силового трансформатора', value: '25–4000 кВА' },
      { name: 'Номинальное напряжение (высокое)', value: '6 или 10 кВ' },
      { name: 'Номинальное напряжение (низкое)', value: '0,4 кВ' },
      { name: 'Степень защиты', value: 'IP54-IP65' },
      { name: 'Температурный режим', value: 'от -60°C до +50°C' }
    ],
    advantages: [
      'Непробиваемая надежность: работают там, где другие выходят из строя',
      'Безопасность на максимум: защита от пыли, влаги и аварий спасает жизни и деньги',
      'Гибкость: подстраиваются под любые условия и задачи',
      'Долговечность: высококачественные материалы и строгие испытания гарантируют годы службы'
    ],
    applications: [
      'Влажные зоны и тропический климат',
      'Пыльные производства и карьеры',
      'Пустынные регионы',
      'Арктические условия',
      'Химические заводы',
      'Морские платформы',
      'Сейсмоопасные регионы'
    ],
    image_url: '/images/ktp/ktps.jpg',
    seo_text: 'Комплектные трансформаторные подстанции для особых условий эксплуатации — это основа стабильного электроснабжения для объектов в экстремальных условиях. Пылевлагозащищенные КТП и КТП для особых условий эксплуатации — настоящие герои энергетики, готовые выдержать любые вызовы природы и технологий. Их прочные корпуса блокируют попадание пыли и влаги, обеспечивая бесперебойную работу там, где обычное оборудование давно бы сдалось. Усиленные конструкции, специальные материалы, системы охлаждения или обогрева — эти подстанции адаптируются под любые требования, чтобы ваш объект оставался под напряжением в любой ситуации.',
    utp: [
      'Работа в экстремальных условиях — от -60°C до +50°C',
      'Защита от пыли и влаги — степень защиты IP54-IP65',
      'Индивидуальный проект под ваши условия'
    ],
    offers: [
      'Бесплатная консультация по подбору защиты',
      'Гарантия 36 месяцев на все компоненты'
    ],
    cta: {
      title: 'Получите расчет для ваших условий эксплуатации!',
      description: 'Сделайте ваше электроснабжение непобедимым!'
    }
  }
}; 